import { gcpManualError$ } from './gcp-manual-error';

export function gcpNotifyErrorManual(error: Error): void {
  gcpManualError$.next(error);
}
